import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import ReplyListItemContainer from 'bundles/discussions/components/repliesList/ReplyListItemContainer';
import { replyPropType } from 'bundles/discussions/lib/propTypes';
import CalloutBox from 'bundles/ui/components/CalloutBox';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/HighlightedReply';

class HighlightedReply extends React.Component {
  static propTypes = {
    reply: replyPropType,
    answerId: PropTypes.string,
    forumLink: PropTypes.string,
    commentId: PropTypes.string,
    fetchAnswerPosition: PropTypes.func.isRequired,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof HighlightedReply.contextTypes>;

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { reply, answerId, commentId, forumLink, fetchAnswerPosition } = this.props;

    if (!reply || reply.hide) {
      return null;
    }

    return (
      <div className="rc-HighlightedReply card-rich-interaction">
        <CalloutBox label={_t('Highlighted Post')}>
          <div className="highlighted-reply-content">
            <ReplyListItemContainer
              // @ts-expect-error ts-migrate(2322) FIXME: Type '{ showJumpLink: true; collapseCommentsByDefa... Remove this comment to see the full error message
              showJumpLink
              collapseCommentsByDefault
              reply={reply}
              answerId={answerId}
              commentId={commentId}
              forumLink={forumLink}
              fetchAnswerPosition={fetchAnswerPosition}
            />
          </div>
        </CalloutBox>
      </div>
    );
  }
}

// @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type '{}'.
export default connectToStores(HighlightedReply, ['ThreadDetailsStore'], ({ ThreadDetailsStore }, { questionId }) => {
  return {
    reply: ThreadDetailsStore.getHighlightedPost(questionId),
  };
});
